module.exports = __webpack_public_path__ + "assets/img/R-C.4dad4009.png";